"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaceTecApp = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = require("react");
var verification_copy_1 = require("../../constants/verification_copy");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_redux_1 = require("react-redux");
var Config_1 = require("../../Config");
var content_dialog_1 = require("../../features/thunks/content-dialog");
var sampleAppController_1 = require("./../../../facetec/src/sampleAppController");
var section_swapper_1 = require("./section_swapper");
var FaceTecApp = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var auth = (0, react_redux_1.useSelector)(function (state) { return state.auth; });
    var firebaseProfile = (0, react_redux_1.useSelector)(function (state) {
        return state.userProfile.profile;
    });
    var facetecState = (0, react_redux_1.useSelector)(function (state) { return state.userProfile.facetec; });
    var isBiometricAuthenticated = (facetecState === null || facetecState === void 0 ? void 0 : facetecState.authenticated) === true;
    var _a = (0, react_1.useState)(Config_1.Config.didSucceed === true), sdkReady = _a[0], setSdkReady = _a[1];
    var _b = (0, react_1.useState)(false), hasTriggered = _b[0], setHasTriggered = _b[1];
    (0, react_1.useEffect)(function () {
        if (Config_1.Config.didSucceed) {
            setSdkReady(true);
            return;
        }
        var interval = setInterval(function () {
            if (Config_1.Config.didSucceed) {
                setSdkReady(true);
                clearInterval(interval);
            }
        }, 500);
        return function () { return clearInterval(interval); };
    }, []);
    (0, react_1.useEffect)(function () {
        // Safety guard: Ensure user is actually logged in (not empty string)
        var isUserLoggedIn = auth.user_id && auth.user_id.trim() !== "";
        // Auto-trigger FaceTec when SDK ready and user present
        if (isUserLoggedIn && sdkReady && !hasTriggered) {
            if (!auth.facetecDBRef) {
                sampleAppController_1.SampleApp.onEnrollUserPressed();
                setHasTriggered(true);
            }
            else if (!isBiometricAuthenticated) {
                sampleAppController_1.SampleApp.onAuthenticateUserPressed(auth.facetecDBRef);
                setHasTriggered(true);
            }
        }
        // Reset trigger flag if user logs out (user_id becomes empty)
        if (!isUserLoggedIn && hasTriggered) {
            setHasTriggered(false);
        }
        // Close dialog when biometric auth completes
        if (isBiometricAuthenticated) {
            dispatch((0, content_dialog_1.closeContentDialogThunk)());
        }
    }, [
        auth.user_id,
        auth.facetecDBRef,
        isBiometricAuthenticated,
        sdkReady,
        hasTriggered,
        dispatch,
    ]);
    return ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.ScreenContainerControl, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center gap-4 pb-16", children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.ScreenContainerControl, { className: "mt-6", children: (0, jsx_runtime_1.jsx)(section_swapper_1.SectionSwapperComponent, { imageSide: "left", image: "", smallTitle: "", bigTitle: "Important: ".concat(verification_copy_1.FACIAL_RECOGNITION), 
                        // buttonText="Learn More"
                        description: "To provide you with the highest level of security, our system uses Facial Recognition as an added layer of protection. This involves a face scan to ensure that only you have access to your account.", content: [
                            "First-Time Users: If this is your first time logging in, you will need to complete a simple Facial Recognition enrolment. During this process, you will be guided through a series of steps to securely capture your face. This one-time setup is quick and easy, and it ensures that your future logins are seamless and highly secure.",
                            "Returning Users: If you have already completed Facial Recognition enrolment, you will be asked to perform a face scan at each login. This verification step is crucial for protecting your account from unauthorised access.",
                        ] }) }), !auth.facetecDBRef && ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Start Enrolment", backgroundColor: "bg-primary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (!sdkReady) {
                                console.warn("FaceTec SDK not initialized yet.");
                                return [2 /*return*/];
                            }
                            sampleAppController_1.SampleApp.onEnrollUserPressed();
                            return [2 /*return*/];
                        });
                    }); }, size: "xsmall", enabled: sdkReady })), auth.facetecDBRef && !isBiometricAuthenticated && ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { label: "Start Authentication", backgroundColor: "bg-primary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (!sdkReady) {
                                console.warn("FaceTec SDK not initialized yet.");
                                return [2 /*return*/];
                            }
                            sampleAppController_1.SampleApp.onAuthenticateUserPressed(auth.facetecDBRef || "");
                            return [2 /*return*/];
                        });
                    }); }, size: "xsmall", enabled: sdkReady })), auth.facetecDBRef && isBiometricAuthenticated && ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2 text-green-600 justify-center items-center", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCheckCircle, size: "4x" }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: verification_copy_1.FACIAL_RECOGNITION_VERIFIED, textColor: "text-green-600", size: "xlarge" })] })), (0, jsx_runtime_1.jsx)("p", { id: "status", "aria-live": "polite", className: "hidden", children: "Initializing..." })] }) }));
};
exports.FaceTecApp = FaceTecApp;
